import { Box } from '@interstate/components/Box';
import { Spinner } from '@interstate/components/Spinner';
import { Alert } from '@interstate/components/Alert';
import { Link } from '@interstate/components/Link';
import { Typography } from '@interstate/components/Typography';
import { CheckCircleIcon } from '@interstate/components/Icons';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom'
import MessageWrapper from './components/message-wrapper/MessageWrapper';
import styles from './Finalize.module.scss'

const centerRow = { display: 'flex', justifyContent: 'center' };

function callFinalize(domain,uuid,otp,callback){
    fetch(`/api/finalize?domain=${encodeURIComponent(domain)}&uuid=${encodeURIComponent(uuid)}&otp=${encodeURIComponent(otp)}`)
        .then(res => callback(null, res.status))
        .catch(err => callback(err,-1));
}

function Finalize(){
    const { tokens } = useInterstateTheme();
    let query = new URLSearchParams(useLocation().search);
    let domain = query.get('domain') || 'manheim-customer';
    let uuid = query.get('uuid');
    let otp = query.get('otp');

    let content_waiting=(
        <Box>
            <Box sx={centerRow}><Spinner aria-label="Validating Your Information" /></Box>
            <Box sx={centerRow}><Typography variant="body-md">Validating Your Information... </Typography></Box>
        </Box>
    );
    let content_done = (
      <Box>
        <Box sx={centerRow}>
          <MessageWrapper>
            <div className={styles.doneContainer}>
              <div className={styles.doneContentWrapper}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <CheckCircleIcon style={{ fontSize: 60, color: tokens.SemColorOnSurfaceSuccessDefault }} />
                  <Typography variant="h1" sx={{ color: tokens.SemColorOnSurfaceSuccessDefault, marginTop: '12px', marginBottom: '24px' }}>Verified!</Typography>
                </Box>
                <Typography variant="body-md" sx={{ textAlign: 'center' }}>
                  Thank you for verifying your contact information.
                </Typography>
              </div>

              <div>
                <Typography variant="body-md" sx={{ textAlign: 'center' }}>
                  You may close this window or continue to&nbsp;
                  <Link href="https://www.manheim.com">Manheim.com.</Link>
                </Typography>
              </div>
            </div>
          </MessageWrapper>
        </Box>
      </Box>
    );
    let content_error = (
      <Box>
        <Box sx={centerRow}>
          <MessageWrapper>
            <Box sx={{ padding: '48px 16px' }}>
              <Alert type="error" role="alert">
                This link has expired. Please logout and log in to verify your
                information. If you need additional assistance, please call
                Manheim Client Care at&nbsp;
                <b>1-866-626-4346</b>.
              </Alert>
            </Box>
          </MessageWrapper>
        </Box>
      </Box>
    );

    const [content,setContent] = useState(content_waiting);
    useEffect(()=>{
        if(!query || !uuid || !otp){
            setContent(content_error);
        }else{
            callFinalize(domain,uuid,otp,
        function(error,code){
                    if(code === 204){
                        setContent(content_done);
                    }else{
                        setContent(content_error);
                    }
                }
            );
        }
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    return <Box className={styles.container}>{content}</Box>;

}

export default Finalize;